import { ContainerTreeObject } from "@/frontend/types/navigationTypes";
import { I18n } from "@/i18n/I18n";
import { CopiedItem, copyPasteTypes, TargetItem } from "@/types/copyPasteTypes";

export function getPasteError(
  targetItem: TargetItem,
  copiedItem: CopiedItem | null,
  containerLookup: {[key: string]: ContainerTreeObject},
  rootId: string
) {
  if (!copiedItem) { return I18n.get('nothingCopied'); }

  if (copiedOperationNotUnderScenario(copiedItem, targetItem)) {
    return I18n.get('operationPasteError');
  }

  if (copiedItemTargetScenarioIsNotOperationOrScenario(copiedItem, targetItem)) {
    return I18n.get('onlyOperationsCanBePastedIntoScenarios');
  }

  if (copiedStepNotUnderSection(copiedItem, targetItem)) {
    return I18n.get('stepPasteError');
  }

  if (copiedSectionUnderOperation(copiedItem, targetItem)) {
    return I18n.get('sectionPasteError');
  }

  if (targetIsContainer(targetItem) && !isValidDepth(copiedItem, targetItem.id, containerLookup, rootId)) {
    return I18n.get('sectionPasteDepthError');
  }

  if (invalidSubjectForParameterPaste(copiedItem, targetItem)) {
    return I18n.get('parameterPasteError');
  }

  if (copiedScenarioNotUnderStepOrScenario(copiedItem, targetItem)) {
    return I18n.get('scenarioPasteError');
  }

  return null;
}

const copiedScenarioNotUnderStepOrScenario = (copiedItem: CopiedItem, targetItem: TargetItem) => {
  return copiedItem.type === copyPasteTypes.Scenario && targetItem.type !== copyPasteTypes.Step && targetItem.type !== copyPasteTypes.Scenario;
};

const copiedOperationNotUnderScenario = (copiedItem: CopiedItem, targetItem: TargetItem) => {
  return copiedItem.type === copyPasteTypes.Operation && targetItem.type !== copyPasteTypes.Operation && targetItem.type !== copyPasteTypes.Scenario;
};

const copiedItemTargetScenarioIsNotOperationOrScenario = (copiedItem: CopiedItem, targetItem: TargetItem) => {
  return copiedItem.type !== copyPasteTypes.Operation && copiedItem.type !== copyPasteTypes.Scenario && targetItem.type === copyPasteTypes.Scenario;
};

const copiedStepNotUnderSection = (copiedItem: CopiedItem, targetItem: TargetItem) => {
  return copiedItem.type === copyPasteTypes.Step && targetItem.type !== copyPasteTypes.Section && targetItem.type !== copyPasteTypes.Step;
};

const copiedSectionUnderOperation = (copiedItem: CopiedItem, targetItem: TargetItem) => {
  return copiedItem.type === copyPasteTypes.Section && targetItem.type === copyPasteTypes.Operation;
};

const targetIsContainer = (targetItem: TargetItem) => {
  return targetItem.type === copyPasteTypes.Section || targetItem.type === copyPasteTypes.Step;
};

const invalidSubjectForParameterPaste = (copiedItem: CopiedItem, targetItem: TargetItem) => {
  return copiedItem.type === copyPasteTypes.Parameter && (targetItem.type === copyPasteTypes.Section || targetItem.type === copyPasteTypes.Scenario);
};

const isValidDepth = (copiedItem: CopiedItem, targetId: string, containerLookup: {[key: string]: ContainerTreeObject}, rootId: string) => {
  if (copiedItem.type !== copyPasteTypes.Section) { return true; }
  const maxTargetDepth = 3 - copiedItem.depth;

  let targetContainer = containerLookup[targetId];
  let targetDepth = 0;
  while (targetContainer.parentId !== rootId) {
    targetContainer = containerLookup[targetContainer.parentId];
    targetDepth += 1;
    if (targetDepth > maxTargetDepth) {
      return false;
    }
  }

  return true;
};
